<template>
  <div>
    <b-row class="mb-5">
      <b-col><h3>Ausstehende Rechnungen</h3></b-col>
      <b-col class="text-right">
        <b-button variant="primary" v-on:click="confirm" :disabled="createDisabled">Jetzt erstellen</b-button>
      </b-col>
    </b-row>

    <b-table-simple>
      <b-thead>
        <b-tr>
          <b-th>Schule</b-th>
          <b-th class="text-center">Anmeldungen</b-th>
          <b-th class="text-center">Teilgenommen</b-th>
          <b-th class="text-center">Abgerechnet</b-th>
          <b-th class="text-center">Offen</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="row in rows" :key="row.registration_id">
          <b-td>
            <router-link :to="{name: 'admin.schools.details', params: {id: row.school.id}}">
              {{ row.school.name }}<br/>
            </router-link>

            <small>{{ row.school.city }}, {{ row.school.state.name }}</small>
          </b-td>
          <b-td class="text-center">{{ row.registrations }}</b-td>
          <b-td class="text-center">{{ row.participated }}</b-td>
          <b-td class="text-center">{{ row.registrationsInvoiced }}</b-td>
          <b-td class="text-center">{{ row.left }}</b-td>
          <b-td>
            <font-awesome-icon icon="spinner" class="fa-spin" v-if="row.status === statusProcessing"></font-awesome-icon>
            <font-awesome-icon :icon="['far', 'times-circle']" v-else-if="row.status === statusFailed"></font-awesome-icon>
            <font-awesome-icon :icon="['far', 'check-circle']" v-else-if="row.status === statusDone" class="clickable"
                v-on:click="$eventHub.$emit('download', '/invoice/' + row.invoice.year + '-' + row.invoice.number)">
            </font-awesome-icon>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'
library.add(faCheckCircle, faTimesCircle)

export default {
  name: 'CompetitionsInvoicing',
  data () {
    return {
      id: this.$route.params.id,
      processing: false,
      rows: []
    }
  },

  created () {
    this.statusIdle = 'idle'
    this.statusProcessing = 'processing'
    this.statusDone = 'done'
    this.statusFailed = 'failed'
  },

  mounted () {
    this.load()
  },

  computed: {
    createDisabled () {
      if (this.processing || !this.rows || this.rows.length === 0) {
        return true
      }

      return this.rows.findIndex(row => row.status === 'idle') === -1
    }
  },

  methods: {
    confirm () {
      const exec = this.exec
      this.$eventHub.$emit(
        'confirm',
        'Rechnungen jetzt erstellen? Die Seite darf nicht verlassen oder neu geladen werden',
        'Rechnungen erstellen',
        exec
      )
    },

    async exec () {
      this.processing = true
      this.$eventHub.$emit('alertHide')

      const config = {
        method: 'POST',
        url: '/invoice',
        data: {
          meta_only: true
        }
      }

      const errors = []
      let processed = 0
      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].status !== this.statusIdle) {
          continue
        }

        processed++

        this.rows[i].status = this.statusProcessing
        config.data.registration_id = this.rows[i].id

        await this.axios(config)
          .then((rsp) => {
            this.rows[i].status = this.statusDone
            this.rows[i].invoice = rsp.data

            document.getElementsByTagName('tr')[i].scrollIntoView({behavior: 'smooth'})
          })
          .catch(e => {
            errors.push(e)
            this.rows[i].status = this.statusFailed
          })
      }

      this.processing = false

      const errorCount = errors.length

      if (processed === 0) {
        this.$eventHub.$emit('info', 'Keine offenen Rechnungen gefunden')
        return
      }

      if (errorCount === 0) {
        this.$eventHub.$emit('info', `${processed} Rechnung(en) erfolgreich erstellt`)
        return
      }

      this.$eventHub.$emit('error', `Es ${errorCount === 1 ? 'ist' : 'sind'} ${errorCount} Fehler aufgetreten`)
    },

    load () {
      this.axios.get('/competitions/' + this.id + '/invoices')
        .catch(e => this.$eventHub.$emit('error', e))
        .then(rsp => {
          if (!rsp.data) {
            return
          }

          rsp.data.forEach(row => {
            this.rows.push({
              id: row.registrationId,
              school: row.school,
              registrations: row.registrations,
              participated: row.participated,
              registrationsInvoiced: row.registrationsInvoiced,
              left: row.left,
              status: this.statusIdle
            })
          })
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/competitions/CompetitionsInvoicing.vue